// extracted by mini-css-extract-plugin
export default {"status":"activeStatusTile_status__EZb7N","square":"activeStatusTile_square__h+QyU"};